import {createStore} from 'redux';
import Common from './common/reducer'
import { persistStore, persistReducer } from 'redux-persist';
// import storageSession from 'redux-persist/lib/storage/session'
import storage from 'redux-persist/lib/storage';
// 数据对象
const persistConfig = {
    key: 'root', // 必须有的
    storage, // 缓存机制
    whitelist: ['currentTheme','collapsed','breadcrumbData','reload',"userInfo",'userList','menu','year','ids','windowInfo','libraryid','libraryarr','libraryname'],
    blacklist: [], // reducer 里不持久化的数据,除此外均为持久化数据
};
// const rootReducer  = combineReducers(allReducer)
// const persistedReducer = persistReducer(persistConfig, rootReducer)
// let store = createStore(persistedReducer, applyMiddleware(thunk));

const myPersistReducer = persistReducer(persistConfig, Common);
const store = createStore(myPersistReducer);

export const persistor = persistStore(store)
export default store
